export function base64ToBlob(base64: string, mimeType: string) {
   let byteCharacters = atob(base64.split(",")[1]);
   let byteNumbers = new Array(byteCharacters.length);
   for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
   }
   let byteArray = new Uint8Array(byteNumbers);
   return new Blob([byteArray], { type: mimeType });
}
